import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { LocalizationService } from '../../../../../services/localization.service';
import { ShopSettingsService } from '../../../../general/services/shop-settings.service';

@Component({
  selector: 'app-partner-code-transaction-list',
  templateUrl: './partner-code-transaction-list.component.html',
  styleUrls: ['./partner-code-transaction-list.component.css']
})
export class PartnerCodeTransactionListComponent implements OnInit {

  @Input()
  transactions = [];

  constructor(
    private localizationService: LocalizationService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit() {
  }

  formatDateTime(dateTime: Date): string {
    return this.localizationService.formatDatetime(dateTime);
  }

  formatMoneyText(amount: number): string {
    return environment.globalSettings.toMoneyStr(amount);
  }

  get isVUMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  get translationTableClass(): string {
    return this.isVUMode ? 'translation-table-vu-mode basket-main-content pb-3' : 'basket-main-content pb-3';
  }
}
